module.exports = __webpack_public_path__ + "images/66e5ddd0767482d0f767cdfd1b877d2e.png";